import Icon from '@mdi/react'
import styled from 'styled-components'
import theme from 'theme_'

export const NewDomainFormContent = styled.div`
  max-width: 320px;
  margin: 0 auto;
  margin-top: 16px;
`
export const AddDomainSuccessIconWrap = styled.div`
  margin-bottom: ${theme.spacing.md};
`
export const AddDomainSuccessIcon = styled(Icon)`
  color: ${theme.colors.success};
`
